import zappy from "@zappy-ride/library.react.components";
import { FormVehicleAttrSelector } from "./FormVehicleAttrSelector";

export * from "./FormVehicleAttrSelector";

zappy.FactoryInstance.registerComponent(FormVehicleAttrSelector);
